<template>
    <Card class="quickpay-pitch">
        <div class="quickpay-pitch__text">
            <p class="quickpay-pitch__title typographies-display-brand-small">
                {{ translations.title }}
            </p>
            <p class="quickpay-pitch__description typographies-paragraph-medium-regular">
                {{ translations.description }}
            </p>
        </div>
        <div class="quickpay-pitch__preview">
            <img :src="illustrationSrc" alt="" class="quickpay-pitch__illustration" />
        </div>
    </Card>
</template>

<script setup lang="ts">
import { inject } from 'vue';
import { Translator } from 'js/shims-vue';
import Card from 'vcomponents/common/card/Card.vue';

const $t = inject('$t') as Translator;

const illustrationSrc = '/ressources/logged/img/icon/svg/quickpay-pitch-illustration.svg';

const translations: Record<string, string> = {
    title: $t.__('quickpay.settings.pitch.title'),
    description: $t.__('quickpay.settings.pitch.description'),
};
</script>

<style lang="scss" scoped>
.quickpay-pitch {
    /* Override default card padding */
    &.quickpay-pitch {
        padding: 40px;
    }
    display: flex;
    gap: 40px;
    align-items: start;
    overflow: hidden;

    &__text {
        width: 302px;
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        gap: var(--spacing-3);
    }

    &__title {
        margin: 0;
        color: var(--colors-sellsy-brand-secondary-blue);
    }

    &__description {
        margin: 0;
        color: var(--colors-sellsy-brand-secondary-blue);
    }

    &__preview {
        flex: 1;
        height: 213px;
        overflow: hidden;
        border-radius: var(--spacing-1);
    }

    &__illustration {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}
</style>
